<template>
    <nav class="menu-wrapper">
        <div :class="{container: container}">
            <div class="menu">
                <ul
                    v-if="items"
                    class="menu-level menu-level-0"
                >
                    <template v-for="item in items">
                        <y-menu-item
                            v-if="item.active"
                            :key="item.id"
                            :item="item"
                            :translation="translation"
                            :arrow="arrow"
                        />
                    </template>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>

    export default {

        name: 'Menu',

        components: {
            YMenuItem: () => import('@groot-components/menu-item'),
        },

        inheritAttrs: false,

        props: {
            /**
             * List of Menu Items
             */
            items: [Array, Object],

            /**
             * Add container class
             */
            container: {
                type   : Boolean,
                default: false,
            },

            /**
             * Arrow for the items with children
             */
            arrow: {
                type   : [Boolean, String, Number],
                default: false,
            },

            /**
             * Translate string
             */
            translation: Boolean,
        },

    };
</script>
